import { gql } from '@apollo/client';

export const ADD_KB_WEBSITE_URL = gql`
  mutation AddKbWebsiteUrl($input: AddKbWebsiteUrlInput!) {
    addKbWebsiteUrl(input: $input) {
      statusCode
      message
      url {
        id
        url
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;
